/**
 * Helpers around the shop's `country` (ISO-3166 alpha-2) attribute.
 *
 * `react-international-phone` expects ISO-2 codes in lowercase. The shop
 * stores them uppercase (`CI`, `SN`, `CM` ...), so we normalise here and
 * keep the dial-code lookup table colocated for forms that need to seed
 * a phone input with the local indicatif.
 */

const DIAL_BY_ISO2: Record<string, string> = {
  CI: '+225',
  SN: '+221',
  CM: '+237',
  BJ: '+229',
  BF: '+226',
  TG: '+228',
  ML: '+223',
  GN: '+224',
  NE: '+227',
  CD: '+243',
  CG: '+242',
  GA: '+241',
  TD: '+235',
  GH: '+233',
  NG: '+234',
};

const DEFAULT_ISO2 = 'CM';

const normalise = (iso2?: string | null): string => {
  if (typeof iso2 === 'string') {
    const trimmed = iso2.trim().toUpperCase();
    if (trimmed.length === 2) return trimmed;
  }
  return DEFAULT_ISO2;
};

/** Returns an ISO-2 lowercase code ready for `react-international-phone`. */
export function getDefaultPhoneCountry(iso2?: string | null): string {
  return normalise(iso2).toLowerCase();
}

/** Returns the `+xxx` dial code for the given country, or the default. */
export function getDialCode(iso2?: string | null): string {
  return DIAL_BY_ISO2[normalise(iso2)] ?? DIAL_BY_ISO2[DEFAULT_ISO2] ?? '+237';
}
